import { NavLink } from "react-router-dom";
import {
  FaHome,
  FaPlayCircle,
  FaNewspaper,
  FaRegNewspaper,
  FaUser,
} from "react-icons/fa";

const activeClass =
  "flex flex-col items-center text-red-600";
const normalClass =
  "flex flex-col items-center text-gray-700";

const MobileBottomNav = () => {
  return (
    <nav
      className="
        fixed bottom-0 left-0 right-0 z-[9999]
        bg-white border-t shadow-md h-14
        flex justify-around items-center
        md:hidden
      "
    >
      {/* Home */}
      <NavLink
        to="/"
        className={({ isActive }) =>
          isActive ? activeClass : normalClass
        }
      >
        <FaHome className="text-lg" />
        <span className="text-[10px] leading-none">Home</span>
      </NavLink>

      {/* Video */}
      <NavLink
        to="/gallery/videos"
        className={({ isActive }) =>
          isActive ? activeClass : normalClass
        }
      >
        <FaPlayCircle className="text-lg" />
        <span className="text-[10px] leading-none">Video</span>
      </NavLink>

      {/* Bundeli News */}
      <NavLink
        to="/bundeli"
        className={({ isActive }) =>
          isActive ? activeClass : normalClass
        }
      >
        <FaNewspaper className="text-lg" />
        <span className="text-[10px] leading-none">बुंदेली</span>
      </NavLink>

      {/* Hindi News */}
      <NavLink
        to="/hindi"
        className={({ isActive }) =>
          isActive ? activeClass : normalClass
        }
      >
        <FaRegNewspaper className="text-lg" />
        <span className="text-[10px] leading-none">हिंदी न्यूज़</span>
      </NavLink>

      {/* Contact */}
      <NavLink
        to="/contact"
        className={({ isActive }) =>
          isActive
            ? "flex flex-col items-center"
            : "flex flex-col items-center"
        }
      >
        <div
          className={`w-8 h-8 rounded-full flex items-center justify-center ${window.location.pathname === "/contact"
              ? "bg-red-600"
              : "bg-gray-400"
            }`}
        >
          <FaUser className="text-white text-sm" />
        </div>
        <span
          className={`text-[10px] leading-none mt-0.5 ${window.location.pathname === "/contact"
              ? "text-red-600"
              : "text-gray-700"
            }`}
        >
          Contact
        </span>
      </NavLink>
    </nav>
  );
};

export default MobileBottomNav;
